import React from 'react';
import power_mother_son from '../../../assets/images/dyslexia/power_mother_son.jpg';
import { motion } from 'framer-motion';

function PowerIntervention() {
  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex flex-col gap-1">
        <h2 className="text-[26px] sm:text-[28px] text-primary font-bold">
          {title}
        </h2>
        <p
          className="text-lg text-secondary max-w-auto lg:max-w-[400px] md:text-xl 2xl:text-2xl"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  return (
    <section className="w-full flex flex-col justify-between gap-4 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 mb-20 relative z-10">
      <h1 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold leading-tight">
        The Power of <br /> Early Intervention
      </h1>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col md:flex-row gap-10">
          <div className="flex-1 flex flex-col gap-4 sm:gap-14">
            <TitleAndDescription
              title=""
              description="The earlier dyslexia is identified, the sooner a child can receive effective support. Early intervention is critical because it can significantly improve a child's reading ability and prevent the long-term academic and emotional struggles that can arise from feeling behind.
"
            />
            <TitleAndDescription
              title="Effective Interventions for Dyslexia:"
              description="<strong>Multisensory Structured Language Education (MSLE):</strong> This is the gold-standard approach for dyslexia instruction. It uses visual, auditory, and kinesthetic-tactile pathways simultaneously to help children make lasting connections between letters and sounds. "
            />
            <TitleAndDescription
              title=""
              description="<strong>The Orton-Gillingham Approach:</strong> This is a highly structured, sequential, and personalized MSLE instructional framework. It explicitly teaches the rules and patterns of language, moving from simple to more complex concepts at the student's own pace. "
            />
          </div>
          <div className="flex-1 flex flex-col gap-4 md:gap-6 ">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={power_mother_son}
                alt="Child in virtual pediatric therapy session at home in Wasilla"
                className="rounded-3xl max-w-auto sm:max-w-[450px] sm:h-[380px] object-cover"
              />
            </motion.div>
            <TitleAndDescription
              title=""
              description="<strong>The Wilson Reading System® (WRS):</strong> As one of the most respected programs based on Orton-Gillingham principles, WRS is an intensive Tier 3 intervention designed for students in second grade through adulthood who have persistent phonological-coding deficits. The program systematically and directly teaches the structure of the English language, ensuring students master concepts like phonology (sounds), orthography (spelling), and morphology (word parts like prefixes and roots) before moving on. Its comprehensive, 12-step curriculum helps students build a solid and lasting foundation for decoding and spelling."
            />
          </div>
        </div>
      </div>
      <div className="w-full mt-6 md:mt-8">
        <p className="text-lg text-secondary w-full md:text-xl 2xl:text-2xl">
          If you have concerns about your child's reading, writing, or overall
          development, please{' '}
          <strong>
            contact Guidepost Pediatrics to schedule a consultation.
          </strong>{' '}
          Our team is dedicated to providing the answers and support your child
          needs to thrive.
        </p>
      </div>
    </section>
  );
}

export default PowerIntervention;
